module.exports = __webpack_public_path__ + "img/Mask Group 101.51e920be.svg";